import React from 'react';
import "./Header.scss"

import mainLogo from "../../Assets/images/main-logo.svg"
import ccIcon from "../../Assets/images/cc-icon.svg"
import tcIcon from "../../Assets/images/tc-icon.svg"
import hsIcon from "../../Assets/images/hs-icon.svg"

const Header = ({ onSignUpClick, onSignInClick }) => (
  <div className="header-top">
    <div className="container">
      <div className="ht-left">
        <div className="ht-logo">
          <img src={mainLogo} alt="Logo" />
        </div>
      </div>
      <div className="ht-right">
        <div className="dropdown h-drop hdb1">
          <a className="dropdown-toggle hd-button" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"> Sign In </a>
          <ul className="dropdown-menu hd-menu hd-menu1">
            <div className="id-inner">
              <ul>
                <li>
                  <a href="#" onClick={(e) => { e.preventDefault(); onSignInClick('cc'); }}>
                    <img className="drop-icon" src={ccIcon} alt="" />
                    Construction Company
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e) => { e.preventDefault(); onSignInClick('tc'); }}>
                    <img className="drop-icon" src={tcIcon} alt="" />
                    Truck Company
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e) => { e.preventDefault(); onSignInClick('hs'); }}>
                    <img className="drop-icon" src={hsIcon} alt="" />
                    HaulSync
                  </a>
                </li>
              </ul>
            </div>
          </ul>
        </div>

        <div className="dropdown h-drop">
          <a className="dropdown-toggle hd-button" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">Sign Up</a>
          <ul className="dropdown-menu hd-menu hd-menu2">
            <div className="id-inner">
              <ul>
                <li>
                  <a href="#" onClick={(e) => { e.preventDefault(); onSignUpClick('cc'); }}>
                    <img className="drop-icon" src={ccIcon} alt="" />
                    Construction Company
                  </a>
                </li>
                <li>
                  <a href="#" onClick={(e) => { e.preventDefault(); onSignUpClick('tc'); }}>
                    <img className="drop-icon" src={tcIcon} alt="" />
                    Truck Company
                  </a>
                </li>
              </ul>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
);

export default Header;
